<template>

  <div class="grid" @dragover.prevent @drop.prevent @drop="subirArchivo" style="height: 50vh;">

    <DataView class="col-12" :value="lstArchivos" :layout="layout">
    <template #header>
        <div class="grid">
          <!-- <div class="col-12">
                <Breadcrumb :home="home" :model="piladirecciones" />
          </div> -->
            <div class="col-6" style="text-align: left">
                  <Button label="Atras" icon="pi pi-chevron-left" class="p-button-sm p-button-rounded p-button-secondary p-button-outlined" @click="atras()" :disabled="piladirecciones.length == 0 || displayNuevaCarpeta"/>
                  <Button label="Nueva carpeta" icon="pi pi-plus" class="p-button-outlined p-button-rounded p-button-sm p-ml-1" @click="showDialogNuevaCarpeta" :disabled="displayNuevaCarpeta"/>
                  <!-- <Button label="Cargar archivo" icon="pi pi-upload" class="p-button-outlined p-button-rounded p-button-success p-ml-1 p-button-sm" /> -->
                  <!-- <FileUpload ref="fil" class="p-button-outlined p-button-rounded p-button-sm p-ml-1" chooseLabel="Subir documento" uploadLabel="Subir" mode="basic" name="archivo[]" :customUpload="true" @uploader="subirArchivo" /> -->

            </div>
            <div class="col-6" style="text-align: right">
                <!-- <InputText v-model="busqueda" placeholder="Busqueda" class="p-ml-1 p-inputtext-sm"/> -->
                <DataViewLayoutOptions v-model="layout"/>
            </div>

        </div>
        <!-- <div class="grid" id="dropzone" @dragover.prevent @drop.prevent @drop="dragFile" style="heigth: 400px;">
          arrastre aqui
        </div> -->
        
    </template>

    <template #list="slotProps">
        <div class="col-12" @dblclick="dblclick(slotProps.data)">
            <div class="product-list-item flex inline-flex pb-1">
                <img style="width: 2em;" :src="'assets/icons/'+slotProps.data.Extension+'.png'" :alt="slotProps.data.Nombre" />
                <div class="product-list-detail">
                    <div class="product-name ml-1">{{slotProps.data.Nombre}}</div>
                    <!-- <Inplace :closable="true">
                        <template #display>
                            {{slotProps.data.Nombre}}
                        </template>
                        <template #content>
                            <InputText class="p-inputtext-sm" v-model="slotProps.data.Nombre" autoFocus />
                        </template>
                    </Inplace> -->
                </div>
            </div>
        </div>
    </template>

    <template #grid="slotProps">
        <div class="col-3 p-2" @dblclick="dblclick(slotProps.data)">
                <div class="flex flex-inline align-items-center">
                    <img class="" style="width: 3em;" :src="'assets/icons/'+slotProps.data.Extension+'.png'" :alt="slotProps.data.Nombre"/>
                    <div class="text-600 pl-1 white-space-nowrap overflow-hidden text-overflow-ellipsis" style="width:10rem">{{slotProps.data.Nombre}}</div>
                    <!-- <Inplace>
                        <template #display>
                            {{slotProps.data.Nombre}}
                        </template>
                        <template #content>
                            <InputText class="p-inputtext-sm" v-model="slotProps.data.Nombre" autoFocus />
                        </template>
                    </Inplace> -->
                </div>
        </div>
    </template>
  </DataView>
  <Dialog header="Nueva carpeta" :visible="displayNuevaCarpeta">
    <div class="">
      <div class="field">
          <!-- <label for="nombrecarpeta">Nombre</label> -->
          <InputText id="nombrecarpeta" type="username" aria-describedby="nombrecarpeta-help" v-model="nombrenuevacarpeta"
                        :class="{
                            'p-invalid': submittedNuevaCarpeta && !nombrenuevacarpeta,
                        }"
          />
          <small v-if="submittedNuevaCarpeta && !nombrenuevacarpeta" id="nombrecarpeta-help" class="p-invalid">Este campo no puede esta vacío.</small>
      </div>
    </div>
    <template #footer>
        <!-- <Button label="Cancelar" icon="pi pi-times" @click="closeDialogCarpeta" class="p-button-text"/> -->
        <Button label="Crear" icon="pi pi-check" @click="submitFormCarpeta" class="p-button-sm" />
    </template>
  </Dialog>
  <Dialog header="Estos archivos no pudieron cargarse correctamente." :visible="mostrarDialogNoAceptados">
    <div class="">
      <DataTable :value="filesNoAceptados" class="p-datatable-sm" responsiveLayout="scroll" :scrollable="true" scrollHeight="400px" style="width: 30vw;">
          <Column field="nombre" header="Nombre"></Column>
          <Column field="motivo" header="Motivo"></Column>
      </DataTable>
    </div>
    <template #footer>
        <!-- <Button label="Cancelar" icon="pi pi-times" @click="closeDialogCarpeta" class="p-button-text"/> -->
        <Button label="Aceptar" icon="pi pi-check" @click="cancelarDialogNoAceptados" class="p-button-sm" />
    </template>
  </Dialog>
          <ProgressBar mode="indeterminate" style="height: .5em" />

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Srvr from "../service/Inventario";
// import axios from "axios";
export default {
  data() {
    return {
      baseUrl : "",
      rutaActual : "",
      lstArchivos : [],
      layout: 'grid',
      busqueda: null,
      home: {icon: 'pi pi-home', to: '/'},
      piladirecciones: [
      ],
      submittedNuevaCarpeta: false,
      nombrenuevacarpeta: null,
      displayNuevaCarpeta: false,
      mostrarDialogNoAceptados: false,
      filesNoAceptados: [],
    }
  },
  created() {
    this.getArchivos();
  },
  mounted() {
    
  },
  methods: {
    dragFile(e) {
        console.log(e.dataTransfer.files);
      },
    getArchivos(){
      var t = this;
      var ctlSvr = new Srvr();
      if(t.piladirecciones.length > 0){
        ctlSvr.getAllDocumentacionSubdir(t,t.rutaActual).then((res) => {
          //console.log(res);
          t.lstArchivos = res;
        });
      }else{
        ctlSvr.getAllDocumentacion(t).then((res) => {
          //console.log(res);
          t.lstArchivos = res;
        });
      }
        
      },
    dblclick(data){
      console.log(data);
      switch (data.Extension){
        case "folder":
          this.piladirecciones.push(data.Nombre);
          this.setrutaactual();
          this.getArchivos();
        break;
        case "url":
          this.abrirUrl(data.Url);
        break;

        default: 
          this.descargarArchivo(data.Nombre);
        break;
      }
      // if(data.Extension == "folder"){
      //   // if(this.piladirecciones[this.piladirecciones.length -1] != data.Nombre){
      //     this.piladirecciones.push(data.Nombre);
      //     this.setrutaactual();
      //     this.getArchivos();
      //   // }
        
      // }else if(data.Extension == "folder"){

      // }
      // else{
      //   this.descargarArchivo(data.Nombre);
      // }
    },
    setrutaactual(){
      this.rutaActual = this.piladirecciones.join("/");
      console.log(this.rutaActual);
    },
    atras(){
      this.piladirecciones.pop();
      this.setrutaactual();
      this.getArchivos();
    },
    descargarArchivo(nombre){
            // var archivo = this.archivoAutorizados.Path.split("\\").pop();
            window.open(this.getUrlServicios+"Documentacion"+"/"+this.rutaActual+"/"+nombre, '_blank');
    },
    abrirUrl(url){
            // var archivo = this.archivoAutorizados.Path.split("\\").pop();
            window.open(url, '_blank');
    },
    showDialogNuevaCarpeta(){
      this.displayNuevaCarpeta = true;
      this.nombrenuevacarpeta = null;
      this.submittedNuevaCarpeta = false;
    },
    closeDialogCarpeta(){
      this.displayNuevaCarpeta = false;
    },
    submitFormCarpeta(){
      var t = this;
      t.submittedNuevaCarpeta = true;

      if(!t.nombrenuevacarpeta) return;

      console.log("enviado")

      var nuevo = t.rutaActual + "/" + t.nombrenuevacarpeta;
      console.log(nuevo);
      var ctlSvr = new Srvr();
        ctlSvr.crearDirectorio(t,nuevo).then((res) => {
          //console.log(res);
          if(res){
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Carpeta creada exitosamente.",
              life: 3000,
            }); 
            t.submittedNuevaCarpeta = false;
            t.closeDialogCarpeta();
            t.getArchivos();
          }else{
            t.$toast.add({
              severity: "warn",
              summary: "AVISO",
              detail: "Se ha producido un error.",
              life: 3000,
            });
          }
        });

    },
    subirArchivo(event){
      console.log(event.dataTransfer.files);
            this.cargaArchivos(event.dataTransfer.files);
    },
    cancelarDialogNoAceptados(){
      this.mostrarDialogNoAceptados = false;
    }, 
    // cargaArchivo(mfile) {
    //         var t = this;
    //         var file = mfile;
    //         var ext = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);

    //         if (ext.length > 0 && ext.length <= 4) {
    //             if (file.size <= 5000000) {
    //             var srv = new Srvr();
    //             var reader = new FileReader();
    //             var fileByteArray = [];
    //             reader.readAsArrayBuffer(file);
    //             reader.onloadend = function (evt) {
    //                 if (evt.target.readyState == FileReader.DONE) {
    //                 var arrayBuffer = evt.target.result,
    //                     array = new Uint8Array(arrayBuffer);
    //                 for (var i = 0; i < array.length; i++) {
    //                     fileByteArray.push(array[i]);
    //                 }

    //                 var newFileName = file.name; //+ "." + ext;
    //                 newFileName = newFileName.replace(" ", "");
    //                 newFileName = newFileName.replace("_", "");
    //                 //datos ui cc
    //                 var formData = {
    //                     fileBytes: fileByteArray,
    //                     fileName: newFileName,
    //                     directorio : t.rutaActual
    //                 };

    //                 srv.cargarArchivoDirectorio(t, formData).then((res) => {
    //                     if(res != null){
    //                         t.$toast.add({
    //                                 severity:"success",
    //                                 summary:"Aviso",
    //                                 detail:"El archivo se ha subido correctamente.",
    //                                 life: 3000
    //                         });
    //                         t.getArchivos();
    //                         // t.$refs.fil.clear();
                            
    //                     }

    //                 })
    //                 .catch(function(error){
    //                         console.log(error);
    //                     });
    //                 }
    //             };
    //             } else {
    //             t.$toast.add({
    //                 severity: "warn",
    //                 summary: "ALERTA",
    //                 detail:
    //                 "El archivo sobrepasa el limite de 5Mb, por favor intenta con otro archivo",
    //                 life: 6000,
    //             });
    //             // t.$refs.fil.clear();

    //             }
    //         } else {
    //             t.$toast.add({
    //             severity: "warn",
    //             summary: "ALERTA",
    //             detail:
    //                 "El archivo no cuenta con una extensión de tipo de archivo valida. Intente con otro archivo",
    //             life: 6000,
    //             });
    //         }
    //     },
        cargaArchivos(mfiles) {
            var t = this;
            var files = mfiles;
            t.filesNoAceptados = [];
            // var filesAceptados = [];
            var readers = [];
            t.mostrarProgreso = true;
            for(var i = 0; i < files.length ; i++){
              var ext = files[i].name.slice(((files[i].name.lastIndexOf(".") - 1) >>> 0) + 2);

              if (ext.length > 0 && ext.length <= 4) {
                  if (files[i].size <= 5000000) {
                    readers.push(t.readFileBuffer(files[i]));
                  } else {
                    // t.$toast.add({
                    //     severity: "warn",
                    //     summary: "ALERTA",
                    //     detail:
                    //     "El archivo sobrepasa el limite de 5Mb, por favor intenta con otro archivo",
                    //     life: 6000,
                    // });
                    t.filesNoAceptados.push({ nombre : files[i].name, motivo: "El archivo sobrepasa el limite de 5Mb, por favor intenta con otro archivo"});
                    // t.$refs.fil.clear();

                  }
              } else {
                  // t.$toast.add({
                  // severity: "warn",
                  // summary: "ALERTA",
                  // detail:
                  //     "El archivo no cuenta con una extensión de tipo de archivo valida. Intente con otro archivo",
                  // life: 6000,
                  // });
                  t.filesNoAceptados.push({ nombre :files[i].name, motivo: "El archivo no cuenta con una extensión de tipo de archivo valida. Intente con otro archivo"});


              }

            }
            
            if(t.filesNoAceptados.length > 0){
              this.mostrarDialogNoAceptados = true;
            }

            Promise.all(readers).then((values) => {
              t.mostrarProgreso = false;
                      var srv = new Srvr();
                      srv.cargarArchivoDirectorio(t, {directorio : t.rutaActual, files : values}).then((res) => {
                          if(res != null){
                              t.$toast.add({
                                      severity:"success",
                                      summary:"Aviso",
                                      detail:"El archivo se ha subido correctamente.",
                                      life: 3000
                              });
                              t.getArchivos();
                              // t.$refs.fil.clear();
                              
                          }

                      })
                      .catch(function(error){
                              console.log(error);
                          });
                  });
                      // var srv = new Srvr();
                      // srv.cargarArchivoDirectorio(t, {directorio : t.rutaActual, files : filesAceptados}).then((res) => {
                      //     if(res != null){
                      //         t.$toast.add({
                      //                 severity:"success",
                      //                 summary:"Aviso",
                      //                 detail:"El archivo se ha subido correctamente.",
                      //                 life: 3000
                      //         });
                      //         t.getArchivos();
                      //         // t.$refs.fil.clear();
                              
                      //     }

                      // })
                      // .catch(function(error){
                      //         console.log(error);
                      //     });

            // console.log(filesAceptados);
            // console.log(filesNoAceptados);
            
        },
        readFileBuffer(file){
          return new Promise(function(resolve,reject){
                    // let fr = new FileReader();

                    // fr.onload = function(){
                    //     resolve(fr.result);
                    // };

                    // fr.onerror = function(){
                    //     reject(fr);
                    // };

                    // fr.readAsText(file);
                    var reader = new FileReader();
                    var fileByteArray = [];
                    reader.onloadend = function (evt) {
                        if (evt.target.readyState == FileReader.DONE) {
                          console.log(evt.target.result);
                          var arrayBuffer = evt.target.result,
                              array = new Uint8Array(arrayBuffer);
                          for (var x = 0; x < array.length; x++) {
                              fileByteArray.push(array[x]);
                          }

                          var newFileName = file.name; //+ "." + ext;
                          newFileName = newFileName.replace(" ", "");
                          newFileName = newFileName.replace("_", "");
                          //datos ui cc
                          var formData = {
                              fileBytes: fileByteArray,
                              fileName: newFileName,
                              // directorio : t.rutaActual
                          };
                          // console.log(formData);
                          resolve(formData)
                        }else{
                          reject(reader);
                        }
                    }
                    // reader.readAsArrayBuffer(file);
                    reader.readAsText(file);
                    
            });
        }
  },
  computed:{
        ...mapGetters(['getUsuarioLogueado','getUrlServicios']),
  },
};

</script>
<style>
.p-fileupload > .p-button{
    background: rgba(33, 150, 243, 0.04);
    color: #689F38;
    border: 1px solid;
    border-radius: 2rem;
    font-size: 0.875rem;
    padding: 0.4375rem 0.875rem;
}

.p-fileupload > .p-button:hover {
    background: rgba(33, 150, 243, 0.04);
    color: #689F38;
    border: 1px solid;
}

.p-fileupload{
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    vertical-align: bottom;
    text-align: center;
    overflow: hidden;
    position: relative;
}

</style>


